module.exports = __webpack_public_path__ + "img/icon-come-funziona-confronto.d5768a7d.svg";